const API_BASE = window.origin ?? "http://localhost:4000"

export const getFileUrl = (
  organizationId: string,
  entity: string,
  fileName?: string | null,
  container: string = "public",
) => `${API_BASE}/api/${container}/${organizationId}/${entity}/${fileName}`

export const getUserImageUrl = (organizationId: string, image?: string | null) =>
  !image
    ? undefined
    : /^https?:\/\//.test(image)
      ? image
      : getFileUrl(organizationId, "user", image)
